import React from "react";
import PokemonList from "../features/PokemonList/PokemonList";

function App() {
  return (
    <>
      <PokemonList />
    </>
  );
}

export default App;